import { Dialog, Transition } from '@headlessui/react'
import moment from 'moment'
import React, { Fragment, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { getAllNotificationAPI } from '../../API/Api'
import { clearNotifications } from '../../Redux/Slice/LoginSlice'
import { toast } from 'react-toastify'
import { IconBell, IconX } from '@tabler/icons-react'

export const NotificationSlide = ({ openSlide, setOpenSlide }) => {
    const userDetails = useSelector((state) => state?.login?.userDetails);
    const notificationDetails = useSelector((state) => state?.login?.notificationDetails);
    const notifyCount = notificationDetails?.length;
    const [notificationDatas, setNotificationData] = useState([]);
    const dispatch = useDispatch();

    const fetchNotifications = async () => {
        try {
            const data = {
                companyId: userDetails?.company?._id,
                userId: userDetails?._id,
                user: ''
            };
            const notificationData = await getAllNotificationAPI(data);
            if (notificationData?.status === 200) {
                setNotificationData(Array.isArray(notificationData?.data?.data) ? notificationData?.data?.data : []);
                dispatch(clearNotifications());
            } else {
                toast.error(notificationData?.data?.error);
            }
        } catch (error) {
            console.error('Failed to fetch notifications:', error);
            setNotificationData([]);
        }
    };
    const handleBellClick = () => {
        setOpenSlide(true)
        fetchNotifications()
    }

    return (
        <>
            {/* Bell Icon */}
            <button className="relative" onClick={handleBellClick}>
                {notifyCount > 0 && (
                    <span className="absolute flex top-0 bottom-2 right-[-10px] h-6 w-6">
                        <span className="absolute inline-flex w-4 h-4 bg-red-400 rounded-full opacity-75 animate-ping"></span>
                        <span className="relative inline-flex w-4 h-4 bg-red-500 rounded-full text-white items-center justify-center">{notifyCount}</span>
                    </span>
                )}
                <IconBell size="31" color="#6A7282"/>
            </button>

            <Transition.Root show={openSlide} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setOpenSlide}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-in-out duration-500"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in-out duration-500"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-10 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-hidden">
                        <div className="absolute inset-0 overflow-hidden">
                            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                                <Transition.Child
                                    as={Fragment}
                                    enter="transform transition ease-in-out duration-500 sm:duration-700"
                                    enterFrom="translate-x-full"
                                    enterTo="translate-x-0"
                                    leave="transform transition ease-in-out duration-500 sm:duration-700"
                                    leaveFrom="translate-x-0"
                                    leaveTo="translate-x-full"
                                >
                                    <Dialog.Panel className="pointer-events-auto relative w-screen max-w-md">
                                        <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
                                            <div className="px-4 sm:px-6 flex flex-row justify-between">
                                                <Dialog.Title className="text-xl  font-semibold leading-6 text-base-color">
                                                    Notifications
                                                </Dialog.Title>
                                                <div className='flex gap-3'>
                                                    <button
                                                        type="button"
                                                        className="relative rounded-md text-black hover:text-base-color hover:ring-2"
                                                        onClick={() => setOpenSlide(false)}
                                                    >
                                                        <span className="absolute -inset-2.5" />
                                                        <span className="sr-only">Close panel</span>
                                                        <IconX stroke={1.5} size={23} color="#000" />
                                                    </button>
                                                </div>
                                            </div>
                                            {Array.isArray(notificationDatas) && notificationDatas?.map((data) => {
                                                const capitalize = (str = "") => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
                                                const firstName = capitalize(data?.userId?.first_name);
                                                const lastName = capitalize(data?.userId?.last_name);
                                                const userFullName = `${firstName} ${lastName}`;
                                                const bodyWithName = data?.body?.replace(data?.userId?._id, userFullName);
                                                return (
                                                    <>
                                                        <div key={data?._id} className='flex justify-center mt-5 mx-5'>
                                                            <NavLink
                                                                className="w-full px-5 py-3  bg-white border border-gray-200 rounded-lg shadow hover:border-sky-400 ">
                                                                <div className='flex justify-between'>
                                                                    <h5 className="text-xl font-bold tracking-tight text-base-color ">{data?.title}</h5>
                                                                </div>
                                                                <p className="mb-2 font-normal text-gray-700 ">{bodyWithName}</p>
                                                                <div className='flex justify-between'>
                                                                    <p className="mb-2 font-normal text-gray-700 ">{moment(data?.createdAt).format('h:mm A')}</p>
                                                                    <p className="mb-2 font-normal text-gray-700 ">{moment(data?.createdAt).format('YYYY-MM-DD')}</p>
                                                                </div>
                                                            </NavLink>
                                                        </div>
                                                    </>
                                                )
                                            })}
                                        </div>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </>
    )
}
